import { Col, List, Row } from "antd";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import styles from "./HistoryEvents.module.css";
import {
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import guestImg1 from "../../../../assets/staticImages/guest1.png";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import placeholder from "../../../../assets/dummy.png";
import moment from "moment";

const groups = [
  {
    title: "Family",
    show: true,
    header: {
      name: "You have 3 past events",
      date: "Event Date",
      time: "Event Time",
      guests: "Guests",
    },
    guests: [
      {
        name: "Wedding Ceremony",
        address: "3707 Irving Place, Arnold, MO 63010",
        date: "May 12, 2023",
        time: "8:30 PM",
        guests: 300,
      },
      {
        name: "Engagement Ceremony",
        address: "3707 Irving Place, Arnold, MO 63010",
        date: "May 15, 2023",
        time: "8:30 PM",
        guests: 485,
      },
      {
        name: "Wedding Shower",
        address: "3707 Irving Place, Arnold, MO 63010",
        date: "May 20, 2023",
        time: "8:30 PM",
        guests: 257,
      },
    ],
  },
];

const TableHeader = ({ item }) => {
  return (
    <Row className={styles.listItemFirst}>
      <Col xs={24} lg={9}>
        <div className={styles.itemGroup1First}>
          <TextComponent text={item.name} textClass={styles.eventTitle} />
        </div>
      </Col>
      <Col xs={24} lg={15}>
        <Row className={styles.itemGroup2First}>
          <Col xs={6} className={styles.group2first}>
            <TextComponent text={item.date} />
          </Col>
          <Col xs={6} className={styles.group2second}>
            <TextComponent text={item.time} />
          </Col>
          <Col xs={6} className={styles.group2third}>
            <TextComponent text={item.guests} textClass={styles.guests} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const LeftGroup = ({ item }) => {
  return (
    <div className={styles.itemGroup1}>
      <img
        src={item?.image ? item?.image : placeholder}
        style={{ width: "60px" }}
      ></img>
      <div className={styles.textGroup}>
        {/* {item.active && (
          <TextComponent
            text={"Active"}
            textClass={styles.activeText}
          ></TextComponent>
        )} */}
        <TextComponent text={item?.name} textClass={styles.eventTitle} />
        <TextComponent text={item?.address} textClass={styles.eventAddr} />
      </div>
    </div>
  );
};

const RightGroup = ({ item }) => {
  return (
    <Row className={styles.itemGroup2}>
      <Col xs={24} sm={8} lg={6} className={styles.group2first}>
        <TextComponent text="Event Date" textClass={styles.infoTitle} />
        <TextComponent text={item.date} />
      </Col>
      <Col xs={24} sm={8} lg={6} className={styles.group2second}>
        <TextComponent text="Event Time" textClass={styles.infoTitle} />
        <TextComponent text={moment(item?.start_time).format("ddd hh:mm A")} />
      </Col>
      <Col xs={24} sm={8} lg={6} className={styles.group2third}>
        <TextComponent text="Guests" textClass={styles.infoTitle} />
        <TextComponent
          text={`${item?.no_of_attendee} Attending`}
          textClass={styles.guests}
        />
      </Col>
    </Row>
  );
};

const HistoryEvents = () => {
  const { height, width } = useWindowDimensions();
  const navigate = useNavigate();

  const Events = useSelector((state) => state.EventReducer.EventHistory);

  const ref = useRef();
  const dispatch = useDispatch();

  useEffect(() => {
    let userData = {
      status: "past",
      name: "",
    };
    dispatch(EventMiddleware.getEvents(userData)).then((data) => {});
  }, []);

  const onSearch = (val) => {
    let userData = {
      status: "past",
      name: val,
    };
    // setSearch(val);
    clearTimeout(ref.current);
    ref.current = setTimeout(() => {
      // setloading(true);
      // setHloading(true);
      dispatch(EventMiddleware.getEvents(userData))
        .then((data) => {
          // setloading(false);
          // setHloading(false);
        })
        .catch(() => {
          // setloading(false);
          // setHloading(false);
        });
    }, 1500);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} xl={9}>
          <SearchInput
            placeholder="Search"
            onChange={(e) => onSearch(e.targer.value)}
          />
        </Col>
      </Row>
      {/* {groups.map((group) => ( */}
      <List
        header={
          <TableHeader
            item={`You have ${
              Events?.length > 0 ? Events?.length : "0"
            } past events`}
          />
        }
        className={styles.list}
        itemLayout={width > 991 ? "horizontal" : "vertical"}
        dataSource={Events}
        renderItem={(item, index) => (
          <List.Item
            className={styles.listItem}
            onClick={() =>
              navigate("/events/eventHistory", { state: { eventData: item } })
            }
          >
            <Col xs={24} lg={9}>
              <LeftGroup item={item} index={index} />
            </Col>
            <Col xs={24} lg={15}>
              <RightGroup item={item} index={index} />
            </Col>
          </List.Item>
        )}
      />
      {/* ))} */}
    </>
  );
};

export default HistoryEvents;
